
import React from 'react';

const GameFAQ = () => {
  const faqs = [
    {
      question: "What is Pokemon Clicker 2?",
      answer: "Pokemon Clicker 2 is a free online idle clicker game based on the Pokemon franchise. Players click to catch and evolve Pokemon, earning currency to purchase upgrades that increase click power and automate progress. It combines the collection aspects of Pokemon with the satisfying progression mechanics of idle games."
    },
    {
      question: "How do I get started playing Pokemon Clicker 2?",
      answer: "Simply load the game in your web browser—no download or installation required! Click on the Pokemon to earn points, then use those points to purchase upgrades. Start by focusing on click power upgrades and then gradually invest in auto-clickers to generate passive income."
    },
    {
      question: "Is Pokemon Clicker 2 free to play?",
      answer: "Yes! Pokemon Clicker 2 is completely free to play online. There are no paywalls, advertisements, or microtransactions. All features and content are available to all players without any monetary investment required."
    },
    {
      question: "How do I save my progress in Pokemon Clicker 2?",
      answer: "Pokemon Clicker 2 automatically saves your progress to your browser's local storage. As long as you use the same browser and don't clear your cache/cookies, your progress will persist between sessions. For additional security, some versions of the game may offer cloud save options or export/import save features."
    },
    {
      question: "Can I play Pokemon Clicker 2 on mobile devices?",
      answer: "Yes! Pokemon Clicker 2 is designed to work on any device with a modern web browser, including smartphones and tablets. The interface automatically adapts to different screen sizes for an optimal experience on any device."
    },
    {
      question: "How do I evolve Pokemon in the game?",
      answer: "Pokemon evolution requires meeting specific conditions, typically a combination of clicks and special items. Each Pokemon has unique evolution requirements. Once a Pokemon is eligible for evolution, an 'Evolve' button will appear. Evolution significantly increases a Pokemon's contribution to your clicking power and unlocks new abilities."
    },
    {
      question: "What's the fastest way to progress in Pokemon Clicker 2?",
      answer: "The most efficient progression strategy involves balancing click power upgrades with auto-clickers. Early on, focus on increasing your click power to generate currency quickly. Then gradually invest in auto-clickers to generate passive income. Complete achievements to earn bonus resources and focus on evolving Pokemon to unlock their full potential."
    },
    {
      question: "What is the prestige system?",
      answer: "The prestige system allows you to reset your progress in exchange for permanent bonuses to your click power and other stats. While you'll lose your currency and purchased upgrades, you'll gain significant multipliers that make subsequent playthroughs much faster. This is a common mechanic in idle games that extends gameplay and provides a sense of long-term progression."
    },
    {
      question: "Can I catch legendary Pokemon?",
      answer: "Yes! Legendary Pokemon are rare encounters that typically require special conditions to be met, such as reaching a certain number of total clicks or completing specific achievements. They provide some of the most powerful bonuses in the game, making the effort to catch them worthwhile for long-term progress."
    },
    {
      question: "Are there special events in Pokemon Clicker 2?",
      answer: "Yes, the game occasionally features special limited-time events that offer unique Pokemon, increased encounter rates for rare Pokemon, or bonus resources. These events add variety to the gameplay and provide opportunities to catch Pokemon that might be difficult to obtain otherwise."
    },
    {
      question: "How many Pokemon are available to catch?",
      answer: "Pokemon Clicker 2 features over 150 Pokemon from the original generation, including all starter Pokemon, evolutions, and legendary creatures. Completing your Pokedex by catching all available Pokemon is one of the main long-term goals of the game and provides substantial bonuses."
    },
    {
      question: "Can I battle other players in Pokemon Clicker 2?",
      answer: "The main version of Pokemon Clicker 2 focuses on the single-player collection and progression experience. However, the game does feature gym battles against AI opponents as you progress, allowing you to test your Pokemon team's strength against classic Pokemon gym leaders."
    },
    {
      question: "What should I do if the game isn't loading properly?",
      answer: "If you encounter loading issues, try refreshing the page, clearing your browser cache, or trying a different web browser. Make sure your browser is updated to the latest version. If problems persist, check your internet connection or try accessing the game at a later time."
    },
    {
      question: "How do Pokemon types affect gameplay?",
      answer: "Different Pokemon types provide various bonuses to your clicking efficiency. For example, Fire types might increase critical click chances, Water types could boost auto-generation rates, and Electric types might improve special item drop rates. Building a diverse team with multiple types can provide a well-rounded set of bonuses."
    },
    {
      question: "Is Pokemon Clicker 2 suitable for children?",
      answer: "Yes! Pokemon Clicker 2 is family-friendly and suitable for players of all ages. The game contains no violent content, inappropriate language, or complex mechanics that would be difficult for younger players to understand. The simple clicking mechanics make it accessible even to very young Pokemon fans."
    }
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-lg shadow-xl overflow-hidden">
        <div className="p-6 sm:p-10">
          <h2 className="text-3xl font-bold text-center text-white mb-8">
            Frequently Asked Questions
          </h2>
          
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg">
            <div className="divide-y divide-gray-200 dark:divide-gray-700">
              {faqs.map((faq, index) => (
                <div key={index} className="py-6 first:pt-0 last:pb-0">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {faq.question}
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
            
            <div className="mt-10 pt-6 border-t border-gray-200 dark:border-gray-700">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                Still Have Questions?
              </h3>
              <p className="text-gray-700 dark:text-gray-300">
                If you have questions that aren't answered here, you can check out community forums and resources where other Pokemon Clicker 2 players share strategies, tips, and answers to common questions. The game's community is friendly and welcoming to new players!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameFAQ;
